interface OneStopBannerProps {
  onContact: () => void;
}

export default function OneStopBanner({ onContact }: OneStopBannerProps) {
  return (
    <section id="one-stop" className="py-20 bg-[#1A2332] relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#0EA5E9]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#0EA5E9]/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <p className="text-[#0EA5E9] text-sm font-semibold tracking-widest mb-5">ONE STOP SERVICE</p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-6">
          会計も、ITも、<br className="block md:hidden" />窓口はひとつ。<br />
          <span className="text-[#0EA5E9]">Zenwest</span> にお任せ！
        </h2>
        <p className="text-gray-300 text-base max-w-2xl mx-auto leading-relaxed mb-12">
          経理のこと、パソコンのこと、ホームページのこと…<br />
          バラバラに相談先を探す必要はありません。<br />
          個人事業主・小規模事業者のデジタル周りを、Zenwestがまるごと引き受けます。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onContact}
            className="bg-[#0EA5E9] text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-[#1A2332] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            無料相談を予約する
          </button>
          <button
            onClick={onContact}
            className="text-white border border-white/30 px-10 py-4 rounded-full text-base hover:border-[#0EA5E9] hover:text-[#0EA5E9] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            まずはお問い合わせ
          </button>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-gray-400">
          <span className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-[#0EA5E9]"></i>
            記帳代行
          </span>
          <span className="text-gray-600">+</span>
          <span className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-[#0EA5E9]"></i>
            会計アプリサポート
          </span>
          <span className="text-gray-600">+</span>
          <span className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-[#0EA5E9]"></i>
            ホームページ制作
          </span>
          <span className="text-gray-600">=</span>
          <span className="flex items-center gap-2 text-white font-semibold">
            <i className="ri-star-fill text-[#0EA5E9]"></i>
            Zenwestひとつで解決
          </span>
        </div>
      </div>
    </section>
  );
}
